import {Injectable} from '@angular/core';
import {CommonService} from './common.service';
import {Roles} from '../models/Roles';

@Injectable({
  providedIn: 'root'
})
export class RolesService {

  constructor(private commonService: CommonService) {
  }

  async getRoles() {
    try {
      const staffRequest = await this.commonService.getList('roles');
      return staffRequest.object as Roles[];
    } catch (e) {
      throw e;
    }
  }
}
